import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';

import ActivityNotificationComponent from '../../components/ActivityNotification';
import Loader from '../../components/Loader';
import Header from '../../components/Header';
import Button from '../../components/Button';
import PageTitle from '../../components/PageTitle';
import { messages as notificationMessages } from '../../components/RepVisitsNotificationsFrame';
import './styles.css';

const messages = defineMessages({
  noNotifications: {
    id: 'activity-notifications.noNotifications',
    defaultMessage: 'You currently have no notifications.',
  },
  showMore: {
    id: 'activity-notifications.noNotifications.showMore',
    defaultMessage: 'Show More',
  },
});

class RepVisitsNotificationsActivity extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    loadMore: PropTypes.func.isRequired,
    displaySidebarComponent: PropTypes.func.isRequired,
    closeSidebar: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  loadMore = () => {
    this.setState({ loading: true });
    this.props.loadMore('viewer.repVisitsNotifications').then(() => this.setState({ loading: false }));
  };

  render() {
    const { viewer } = this.props;
    const notifications = viewer.repVisitsNotifications.edges;
    const { hasNextPage } = viewer.repVisitsNotifications.pageInfo;

    return (
      <div styleName="container">
        <PageTitle subTitle="Activity" title="RepVisits Notifications" category="Intersect" />
        <Header as="h2" styleName="section-title" id="right-side-heading">
          <FormattedMessage {...notificationMessages.activity} />
        </Header>
        {
          notifications.length === 0 ? (
            <div id="no-notifications-msg" styleName="no-notifications-message">
              <FormattedMessage {...messages.noNotifications} />
            </div>
          ): (
            <ul styleName="notifications-container">
              {notifications.map((notification) => (
                <ActivityNotificationComponent
                  notification={notification.node}
                  currentUserId={viewer.uuid}
                  displaySidebarComponent={this.props.displaySidebarComponent}
                  closeSidebar={this.props.closeSidebar}
                  key={notification.node.id}
                />
              ))}
              {hasNextPage && (
              <div styleName="show-more-container">
                <Loader inline active={this.state.loading} />
                <Button basic size="small" id="show-more-link" onClick={this.loadMore}>
                  <FormattedMessage {...messages.showMore} />
                </Button>
              </div>
              )}
            </ul>
          )
        }
      </div>
    );
  }
}

export default injectIntl(RepVisitsNotificationsActivity);
